import React from 'react';
import { cn } from './cn';

/**
 * StatusPill — Active / Inactive / Custom tone chips.
 *
 * Usage:
 *   <StatusPill active />              // green "ACTIVE"
 *   <StatusPill active={false} />      // gray "INACTIVE"
 *   <StatusPill tone="amber">Pending Review</StatusPill>
 */
const TONE_CLASSES = {
  green:  'bg-teal-green text-white',
  gray:   'bg-text-muted text-white',
  amber:  'bg-[#FCEAD1] text-[#8C5A1E]',
  blue:   'bg-[#DCE7F5] text-[#3A4F7A]',
  coral:  'bg-coral-soft text-coral-dark',
  navy:   'bg-navy text-bg',
};

export function StatusPill({ active, tone, children, className }) {
  // Infer tone from `active` boolean when not explicit.
  const resolvedTone = tone || (active === false ? 'gray' : 'green');
  const label = children ?? (active === false ? 'Inactive' : 'Active');
  return (
    <span
      className={cn(
        'inline-flex items-center font-condensed font-bold text-[10px] uppercase',
        'tracking-wider rounded-pill px-2 py-0.5 whitespace-nowrap',
        TONE_CLASSES[resolvedTone],
        className,
      )}
    >
      {label}
    </span>
  );
}

export default StatusPill;
